// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.links[data-v-6079550a]{margin-top:1em}.links[data-v-6079550a] .avatar{padding:0 .5em}`, "",{"version":3,"sources":["webpack://./components/modal/NodeShareModal.vue"],"names":[],"mappings":"AACA,wBACE,cAAA,CAEA,gCACE,cAAA","sourcesContent":["\n.links {\n  margin-top: 1em;\n\n  :deep .avatar {\n    padding: 0 0.5em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
